import { render, staticRenderFns } from "./mr_widget_merging.vue?vue&type=template&id=055a6288&"
import script from "./mr_widget_merging.vue?vue&type=script&lang=js&"
export * from "./mr_widget_merging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mr_widget_merging.vue"
export default component.exports